import './NextButton.scss';

import { NotificationType, useAddNotification, useTranslation } from '../../utils';

import { TNextButtonProps } from '../../utils/types';
import { onLineState } from '../../atoms';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';

const NextButton = ({ link, btnText, isDisable, navState }: TNextButtonProps) => {
  const isOnLine = useRecoilValue(onLineState);
  const navigate = useNavigate();

  const pushNotification = useAddNotification();
  const { t } = useTranslation();

  const goToCreateAppointment = () => {
    isOnLine
      ? navigate(link, { state: navState })
      : pushNotification({
          type: NotificationType.Warning,
          title: t('Web.Title_connection'),
          text: t('Web.Error_offline_mode'),
        });
  };

  return (
    <div className='addButton'>
      <button onClick={goToCreateAppointment} disabled={!!isDisable}>
        <span>{btnText}</span>
        <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.2' className='arrow'>
          <path d='M5 12h14M13 6l6 6-6 6' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
      </button>
    </div>
  );
};

export default NextButton;